import { captureException } from '@sentry/react';
import { isCanceledApiMessage, managerAPI } from '@/shared/api';
import { storeTimeout } from '@/shared/lib/storeTimeout';

/**
 * Records an unexpected API failure so it can be diagnosed later. Ignores errors raised by deliberate request cancellation, otherwise reports the error to Sentry and writes it to the console alongside the given message.
 *
 * @param msg - Context message logged with the error.
 * @param error - Error raised by the failed call.
 * @returns Nothing.
 */
export const logError = (msg: string, error: any) => {
  if (isCanceledApiMessage(error?.message)) {
    return;
  }
  captureException(error);
  console.error(msg, error);
};

/**
 * Aborts every in-flight request and pending timer the app is tracking. Clears both the API cancellation store and the timeout store.
 *
 * @returns Nothing.
 */
export const cancelAllAPI = () => {
  managerAPI.cancelAllStore();
  storeTimeout.cancelAllStore();
};
